<template>
  <div class="exam">
    <div class="nuv">
      <a href="/tjkStudy/examlist" class="active">考试中心</a>&gt;<span>{{ data.examName }}</span>
    </div>
    <div class="result-con">
      <div class="count">
        <h2>考试结果</h2>
        <div class="useTime">
          <p>
            <span class="result-txt" v-if="data.isPassed == 'passed'">恭喜您已通过考试</span>
            <span class="result-txt" v-if="data.isPassed == 'failed'">很遗憾您未通过考试</span>
          </p>
          <p>用时：<span class="blue">{{ getTime(data.examTimeSpent) }}</span></p>
          <p>
            <label>打字速度：</label><span class="num">{{ tjkAnswer.speed }}字/分</span>
            <label>正确率：</label><span class="num">{{ tjkAnswer.accuracy }}%</span>
            <label>总字数：</label><span class="num">{{ tjkAnswer.tjkWordNumber }}字</span>
          </p>
          <p class="txt">及格分数：{{ data.examPassScore }}字/分</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      'data': {},
      'tjkAnswer': {},
      'num': [],
      'savelist': [],
      'list': [], //保存时的结果集转换的一维数组，用作答题卡
       OnInline:'false',//小助手跳转
    }
  },
  mounted: function() {
    this.getExam()
  },
  methods: {
    getExam() {
      var data = {
        'examRecordId': this.id
      }
      this.$http.post(API_ROOT.system + '/tjkExam/getTjkExamDetail', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.data = result.data
         
          this.tjkAnswer = result.data.allTjkAnswerDetailList[0].questionDetailList[0].tjkAnswer
          console.log(this.tjkAnswer.speed,'原')
          
           if(this.data.isPassed=='passed'){window.parent['goBack'](this.tjkAnswer.speed)}
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    getTime(second) {
      var sec = parseInt(second)
      var min = 0
      var hour = 0  
      if(sec >= 60) {
        min = parseInt(sec/60)
        sec = parseInt(sec%60)
        if(min >= 60) {
          hour = parseInt(min/60)
          min = parseInt(min%60)
        }
      }
      hour = hour < 10 ? "0" + hour : hour
      min = min < 10 ? "0" + min : min
      sec = sec < 10 ? "0" + sec : sec
      if(hour > 0 ) {
        return `${hour}小时${min}分钟${sec}秒`
      }else {
        return `${min}分钟${sec}秒`
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/typingResult.vue